/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Strength_StrongInputs */

const en_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const de_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const fr_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const es_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const it_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const nl_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const pl_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const fi_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const da_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

const sv_story_bank_strength_strong = /** @type {(inputs: Story_Bank_Strength_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strong`)
};

/**
* | output |
* | --- |
* | "Strong" |
*
* @param {Story_Bank_Strength_StrongInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_strength_strong = /** @type {((inputs?: Story_Bank_Strength_StrongInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Strength_StrongInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_strength_strong(inputs)
	if (locale === "fr") return fr_story_bank_strength_strong(inputs)
	if (locale === "es") return es_story_bank_strength_strong(inputs)
	if (locale === "it") return it_story_bank_strength_strong(inputs)
	if (locale === "nl") return nl_story_bank_strength_strong(inputs)
	if (locale === "pl") return pl_story_bank_strength_strong(inputs)
	if (locale === "fi") return fi_story_bank_strength_strong(inputs)
	if (locale === "da") return da_story_bank_strength_strong(inputs)
	if (locale === "sv") return sv_story_bank_strength_strong(inputs)
	return en_story_bank_strength_strong(inputs)
});